;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require("babel-runtime/core-js/json/stringify");

var _stringify2 = _interopRequireDefault(_stringify);

var _vueTableDynamic = require("vue-table-dynamic");

var _vueTableDynamic2 = _interopRequireDefault(_vueTableDynamic);

var _sweetalert = require("sweetalert2");

var _sweetalert2 = _interopRequireDefault(_sweetalert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "RevShare",
  props: ["dbrevshares", "agents", "merchants", "agency", "mainagency", "mainmerchant", "agent_margin", "margin", "commission", "agent_commission"],
  data: function data() {
    return {
      account_no: null,
      value: 0,
      new_margin: 0,
      commission_type: null,
      desc: "Agency -Agent margin setup",
      indexes: [],
      topushData: [],
      selectedIndex: null,
      revshares: [],
      final_revshare: null,
      all_parsed_agents: [],
      all_agencies: [],
      all_merchants: [],
      max_margin: 0,
      params: {
        data: null,
        header: "row",
        showCheck: true,
        border: true,
        edit: {
          column: [1, 2],
          cell: [[-1, -1]]
        }
      }
    };
  },

  components: { VueTableDynamic: _vueTableDynamic2.default },
  watch: {
    mainagency: function mainagency(val) {
      if (val != undefined) {
        this.all_parsed_agents = this.all_agencies.filter(function (agent) {
          return agent.id == val;
        });
      }
    },
    mainmerchant: function mainmerchant(val) {
      if (val != undefined) {
        this.all_parsed_agents = this.all_merchants.filter(function (agent) {
          return agent.id == val;
        });
      }
    },
    margin: function margin(val) {
      this.new_margin = val;
    },
    commission: function commission(val) {
      this.commission_type = val;
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.all_agencies = JSON.parse(this.agents);
    this.all_merchants = JSON.parse(this.merchants);
    this.new_margin = this.agent_margin;
    this.params.data = [["Index", "Account Number", "Value"]];
    $("#addRevShare").on("hidden.bs.modal", function () {
      _this.reset();
    });

    var parsed = JSON.parse(this.dbrevshares);

    parsed.forEach(function (part, index, theArray) {
      var accno = theArray[index].account_number;
      var amount = theArray[index].value;
      var desc = theArray[index].desc;
      _this.params.data.push([index + 1, accno, amount]);
      _this.topushData.push({
        account_number: accno,
        value: amount,
        desc: desc
      });
    });
  },


  methods: {
    get_max_margin: function get_max_margin() {
      if (this.commission_type != "fixed") {
        this.max_margin = 100 - this.new_margin;
      } else {
        this.max_margin = this.new_margin;
      }
      return this.max_margin;
    },

    reset: function reset() {
      this.account_no = null;
      this.value = 0;
      this.desc = "Agency -Agent margin setup";
    },
    add_row: function add_row() {
      var _this2 = this;

      if (this.account_no == null) {
        _sweetalert2.default.fire({
          icon: "error",
          title: "Oops...",
          text: "Please select an account"
        });
        return;
      }

      var found = this.topushData.find(function (s) {
        return s.account_number == _this2.account_no.account_id;
      }) || null;

      if (found == null) {
        $("#addRevShare .close").click();
        var i = this.params.data.length - 1;
        this.params.data.push([i + 1, this.account_no.account_id, this.value]);

        this.topushData.push({
          account_number: this.account_no.account_id,
          value: this.value,
          desc: this.desc
        });

        this.final_revshare = (0, _stringify2.default)(this.topushData);
        this.reset_revshare(this.final_revshare);
      } else {
        _sweetalert2.default.fire({
          icon: "error",
          title: "Oops...",
          text: "Revenue share already exists !"
        });
      }
    },
    remove_row: function remove_row() {
      this.params.data.splice(this.selectedIndex, 1);
      this.topushData.$remove(this.topushData[this.selectedIndex - 1]);
      this.final_revshare = (0, _stringify2.default)(this.topushData);
      this.reset_revshare(this.final_revshare);
      this.selectedIndex = null;
    },
    onSelect: function onSelect(isChecked, index, data) {
      if (isChecked) {
        this.indexes.push(index);
        this.selectedIndex = index;
      } else {
        this.indexes.$remove(index);
        this.selectedIndex = null;
      }
    },
    onSelectionChange: function onSelectionChange(checkedDatas, checkedIndexs, checkedNum) {},
    onCellChange: function onCellChange(rowIndex, columnIndex, data) {
      if (columnIndex == 2) {
        this.topushData[rowIndex - 1].value = data;
      } else {
        this.topushData[rowIndex - 1].account_number = data;
      }
      this.final_revshare = (0, _stringify2.default)(this.topushData);
      this.reset_revshare(this.final_revshare);
    },

    reset_revshare: function reset_revshare(val) {
      $("#revshares").val(val);
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-demo",staticStyle:{"width":"600px"}},[_vm._m(0),_vm._v(" "),(_vm.selectedIndex)?_c('a',{staticClass:"btn",attrs:{"href":"javascript:void(0)"},on:{"click":_vm.remove_row}},[_c('i',{staticClass:"fa fa-remove"})]):_vm._e(),_vm._v(" "),_c('vue-table-dynamic',{ref:"table",attrs:{"params":_vm.params},on:{"select":_vm.onSelect,"selection-change":_vm.onSelectionChange,"cell-change":_vm.onCellChange}}),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"addRevShare","tabindex":"-1","role":"dialog","aria-labelledby":"addRevShare","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('form',{attrs:{"onsubmit":"return false;"}},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"modal-body",staticStyle:{"overflow":"auto"}},[_c('div',{staticClass:"md-form mb-5"},[_c('label',{attrs:{"data-error":"wrong","data-success":"right"}},[_vm._v("Which Agency should receive commission ?")]),_vm._v(" "),_c('v-select',{attrs:{"options":_vm.all_parsed_agents,"label":"name"},model:{value:(_vm.account_no),callback:function ($$v) {_vm.account_no=$$v},expression:"account_no"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('label',{attrs:{"data-error":"wrong","data-success":"right"}},[_vm._v("Commission Amount ( should be less than or equal to\n                "),_c('b',[_vm._v(_vm._s(_vm.get_max_margin()))]),_vm._v(")\n              ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"}],staticClass:"form-control",attrs:{"type":"number","min":"0","required":""},domProps:{"value":(_vm.value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.value=$event.target.value}}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.desc),expression:"desc"}],staticClass:"form-control",attrs:{"type":"hidden"},domProps:{"value":(_vm.desc)},on:{"input":function($event){if($event.target.composing){ return; }_vm.desc=$event.target.value}}})],1)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v("\n              Close\n            ")]),_vm._v(" "),(
                _vm.commission_type != 'fixed' &&
                Number(_vm.value) > 0 &&
                Number(_vm.value) <= Number(_vm.max_margin)
              )?_c('input',{staticClass:"btn btn-primary",attrs:{"type":"button","value":"Add RevShare"},on:{"click":_vm.add_row}}):_vm._e(),_vm._v(" "),(_vm.commission_type == 'fixed' && Number(_vm.value) > 0)?_c('input',{staticClass:"btn btn-primary",attrs:{"type":"button","value":"Add RevShare"},on:{"click":_vm.add_row}}):_vm._e()])])])])])],1)}
__vue__options__.staticRenderFns = [function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"btn",attrs:{"href":"javascript:void(0)","data-toggle":"modal","data-target":"#addRevShare"}},[_c('i',{staticClass:"fa fa-plus"})])},function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v("Add Agent - Agency Revenue Share")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])])}]
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-e7019efa", __vue__options__)
  } else {
    hotAPI.reload("data-v-e7019efa", __vue__options__)
  }
})()}